// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/auth_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * LoginAdminArgs メッセージ
 *
 * @generated from message service.LoginAdminArgs
 */
export class LoginAdminArgs extends Message<LoginAdminArgs> {
  /**
   * @generated from field: string mail = 1;
   */
  mail = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  constructor(data?: PartialMessage<LoginAdminArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.LoginAdminArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LoginAdminArgs {
    return new LoginAdminArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LoginAdminArgs {
    return new LoginAdminArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LoginAdminArgs {
    return new LoginAdminArgs().fromJsonString(jsonString, options);
  }

  static equals(a: LoginAdminArgs | PlainMessage<LoginAdminArgs> | undefined, b: LoginAdminArgs | PlainMessage<LoginAdminArgs> | undefined): boolean {
    return proto3.util.equals(LoginAdminArgs, a, b);
  }
}

/**
 * ChangePasswordArgs メッセージ
 *
 * @generated from message service.ChangePasswordArgs
 */
export class ChangePasswordArgs extends Message<ChangePasswordArgs> {
  /**
   * @generated from field: string admin_user_id = 1 [json_name = "admin_user_id"];
   */
  adminUserId = "";

  /**
   * @generated from field: string old_password = 2 [json_name = "old_password"];
   */
  oldPassword = "";

  /**
   * @generated from field: string new_password = 3 [json_name = "new_password"];
   */
  newPassword = "";

  constructor(data?: PartialMessage<ChangePasswordArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ChangePasswordArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_user_id", jsonName: "admin_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "old_password", jsonName: "old_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "new_password", jsonName: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangePasswordArgs {
    return new ChangePasswordArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangePasswordArgs {
    return new ChangePasswordArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangePasswordArgs {
    return new ChangePasswordArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ChangePasswordArgs | PlainMessage<ChangePasswordArgs> | undefined, b: ChangePasswordArgs | PlainMessage<ChangePasswordArgs> | undefined): boolean {
    return proto3.util.equals(ChangePasswordArgs, a, b);
  }
}

/**
 * CreateAdminUserWithPasswordArgs メッセージ
 *
 * @generated from message service.CreateAdminUserWithPasswordArgs
 */
export class CreateAdminUserWithPasswordArgs extends Message<CreateAdminUserWithPasswordArgs> {
  /**
   * @generated from field: string mail = 1;
   */
  mail = "";

  /**
   * @generated from field: string admin_name = 2 [json_name = "admin_name"];
   */
  adminName = "";

  /**
   * @generated from field: string password = 3;
   */
  password = "";

  /**
   * @generated from field: bool is_debug_user = 4 [json_name = "is_debug_user"];
   */
  isDebugUser = false;

  constructor(data?: PartialMessage<CreateAdminUserWithPasswordArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateAdminUserWithPasswordArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "admin_name", jsonName: "admin_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_debug_user", jsonName: "is_debug_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdminUserWithPasswordArgs {
    return new CreateAdminUserWithPasswordArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdminUserWithPasswordArgs {
    return new CreateAdminUserWithPasswordArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdminUserWithPasswordArgs {
    return new CreateAdminUserWithPasswordArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdminUserWithPasswordArgs | PlainMessage<CreateAdminUserWithPasswordArgs> | undefined, b: CreateAdminUserWithPasswordArgs | PlainMessage<CreateAdminUserWithPasswordArgs> | undefined): boolean {
    return proto3.util.equals(CreateAdminUserWithPasswordArgs, a, b);
  }
}

/**
 * UpdateAdminUserProfileArgs メッセージ
 *
 * @generated from message service.UpdateAdminUserProfileArgs
 */
export class UpdateAdminUserProfileArgs extends Message<UpdateAdminUserProfileArgs> {
  /**
   * @generated from field: string admin_user_id = 1 [json_name = "admin_user_id"];
   */
  adminUserId = "";

  /**
   * @generated from field: string admin_name = 2 [json_name = "admin_name"];
   */
  adminName = "";

  /**
   * @generated from field: bool is_debug_user = 3 [json_name = "is_debug_user"];
   */
  isDebugUser = false;

  /**
   * @generated from field: string new_password = 4 [json_name = "new_password"];
   */
  newPassword = "";

  constructor(data?: PartialMessage<UpdateAdminUserProfileArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateAdminUserProfileArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_user_id", jsonName: "admin_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "admin_name", jsonName: "admin_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_debug_user", jsonName: "is_debug_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "new_password", jsonName: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdminUserProfileArgs {
    return new UpdateAdminUserProfileArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdminUserProfileArgs {
    return new UpdateAdminUserProfileArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdminUserProfileArgs {
    return new UpdateAdminUserProfileArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdminUserProfileArgs | PlainMessage<UpdateAdminUserProfileArgs> | undefined, b: UpdateAdminUserProfileArgs | PlainMessage<UpdateAdminUserProfileArgs> | undefined): boolean {
    return proto3.util.equals(UpdateAdminUserProfileArgs, a, b);
  }
}

/**
 * LoginAdminReply メッセージ
 *
 * @generated from message service.LoginAdminReply
 */
export class LoginAdminReply extends Message<LoginAdminReply> {
  /**
   * @generated from field: string admin_user_id = 1 [json_name = "admin_user_id"];
   */
  adminUserId = "";

  /**
   * @generated from field: string mail = 2;
   */
  mail = "";

  /**
   * @generated from field: string admin_name = 3 [json_name = "admin_name"];
   */
  adminName = "";

  /**
   * @generated from field: bool is_first_login = 4 [json_name = "is_first_login"];
   */
  isFirstLogin = false;

  /**
   * @generated from field: string token = 5;
   */
  token = "";

  constructor(data?: PartialMessage<LoginAdminReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.LoginAdminReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_user_id", jsonName: "admin_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "admin_name", jsonName: "admin_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_first_login", jsonName: "is_first_login", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LoginAdminReply {
    return new LoginAdminReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LoginAdminReply {
    return new LoginAdminReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LoginAdminReply {
    return new LoginAdminReply().fromJsonString(jsonString, options);
  }

  static equals(a: LoginAdminReply | PlainMessage<LoginAdminReply> | undefined, b: LoginAdminReply | PlainMessage<LoginAdminReply> | undefined): boolean {
    return proto3.util.equals(LoginAdminReply, a, b);
  }
}

/**
 * ChangePasswordReply メッセージ
 *
 * @generated from message service.ChangePasswordReply
 */
export class ChangePasswordReply extends Message<ChangePasswordReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<ChangePasswordReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ChangePasswordReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangePasswordReply {
    return new ChangePasswordReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangePasswordReply {
    return new ChangePasswordReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangePasswordReply {
    return new ChangePasswordReply().fromJsonString(jsonString, options);
  }

  static equals(a: ChangePasswordReply | PlainMessage<ChangePasswordReply> | undefined, b: ChangePasswordReply | PlainMessage<ChangePasswordReply> | undefined): boolean {
    return proto3.util.equals(ChangePasswordReply, a, b);
  }
}

/**
 * CreateAdminUserWithPasswordReply メッセージ
 *
 * @generated from message service.CreateAdminUserWithPasswordReply
 */
export class CreateAdminUserWithPasswordReply extends Message<CreateAdminUserWithPasswordReply> {
  /**
   * @generated from field: string admin_user_id = 1 [json_name = "admin_user_id"];
   */
  adminUserId = "";

  constructor(data?: PartialMessage<CreateAdminUserWithPasswordReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateAdminUserWithPasswordReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "admin_user_id", jsonName: "admin_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAdminUserWithPasswordReply {
    return new CreateAdminUserWithPasswordReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAdminUserWithPasswordReply {
    return new CreateAdminUserWithPasswordReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAdminUserWithPasswordReply {
    return new CreateAdminUserWithPasswordReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAdminUserWithPasswordReply | PlainMessage<CreateAdminUserWithPasswordReply> | undefined, b: CreateAdminUserWithPasswordReply | PlainMessage<CreateAdminUserWithPasswordReply> | undefined): boolean {
    return proto3.util.equals(CreateAdminUserWithPasswordReply, a, b);
  }
}

/**
 * UpdateAdminUserProfileReply メッセージ
 *
 * @generated from message service.UpdateAdminUserProfileReply
 */
export class UpdateAdminUserProfileReply extends Message<UpdateAdminUserProfileReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<UpdateAdminUserProfileReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateAdminUserProfileReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAdminUserProfileReply {
    return new UpdateAdminUserProfileReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAdminUserProfileReply {
    return new UpdateAdminUserProfileReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAdminUserProfileReply {
    return new UpdateAdminUserProfileReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAdminUserProfileReply | PlainMessage<UpdateAdminUserProfileReply> | undefined, b: UpdateAdminUserProfileReply | PlainMessage<UpdateAdminUserProfileReply> | undefined): boolean {
    return proto3.util.equals(UpdateAdminUserProfileReply, a, b);
  }
}

